/**
 * B+ PoC — afwerking filteren op geselecteerde "Geschikte ruimte" + teller.
 *
 * Werkt samen met paint-application-filter.js / variant-picker.js: leest de
 * geselecteerde ruimte (de checked radio in <paint-application-filter>) en toont
 * alleen afwerking-kaarten waarvan data-application die ruimte bevat. Draait bij
 * load (de juiste ruimte-radio is server-side al `checked`) én bij elke wijziging.
 *
 * Tijdelijk onderdeel van de PoC; nette integratie volgt met de echte velden.
 */
(function () {
  if (window.__afwRuimteCountInit) return;
  window.__afwRuimteCountInit = true;

  function selectedRuimte() {
    var pf = document.querySelector('paint-application-filter');
    if (!pf) return null;
    var checked = pf.querySelector('input[type="radio"]:checked');
    if (checked) return (checked.getAttribute('data-application') || checked.value || '').trim();
    var fc = pf.getAttribute('data-debug-first-compatible');
    if (fc && fc !== 'null' && fc !== '') return fc.trim();
    return null;
  }

  function apply() {
    var fieldset = document.querySelector('.variant-option--afwerking-cards');
    if (!fieldset) return;

    var ruimte = selectedRuimte();
    var labels = fieldset.querySelectorAll('.variant-option__button-label');

    labels.forEach(function (label) {
      var raw = label.getAttribute('data-application') || '';
      var apps = raw.split(',').map(function (s) { return s.trim(); });
      var match = !ruimte || apps.indexOf(ruimte) !== -1;

      if (match) {
        label.classList.remove('afw-ruimte-hidden');
        // toon matchende kaarten meteen bij load (vóór variant-picker.js draait)
        label.classList.remove('variant-option--hidden-by-liquid');
      } else {
        label.classList.add('afw-ruimte-hidden');
      }
    });
  }

  function init() {
    apply();
    document.addEventListener('paint-filter:changed', apply);
    document.addEventListener('paint-filter:cleared', apply);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('paint-application-filter')) apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
